export default __webpack_public_path__ + "static/media/Greece.cadaa850.svg";